module.exports = __webpack_public_path__ + "static/media/exempleiswrong.a1e34605.mp3";